import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "change-password-card" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-6" }
const _hoisted_4 = { class: "trezo-form-group" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "trezo-form-group" }
const _hoisted_7 = { class: "col-sm-12" }
const _hoisted_8 = { class: "trezo-form-group" }
const _hoisted_9 = { class: "form-btn-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_label = _resolveComponent("v-label")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_label, { class: "main-label d-block fw-medium text-black" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode(" Old Password ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_text_field, { label: "Enter old password" })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_v_label, { class: "main-label d-block fw-medium text-black" }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode(" New Password ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_text_field, { label: "Enter new password" })
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_v_label, { class: "main-label d-block fw-medium text-black" }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode(" Confirm Password ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_text_field, { label: "Enter confirm password" })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _cache[4] || (_cache[4] = _createElementVNode("button", {
        type: "button",
        class: "primary"
      }, [
        _createElementVNode("i", { class: "material-symbols-outlined" }, " check "),
        _createTextVNode(" Change Password ")
      ], -1)),
      _createVNode(_component_RouterLink, {
        to: "/authentication/forgot-password",
        class: "p-0 h-auto fs-14 text-danger"
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode(" Forgot Password? ", -1)
        ]))]),
        _: 1
      })
    ])
  ]))
}